<app-header></app-header>
<div class="pb-1">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>